import type {SourceSelector} from './types';
import SliderData from "./SliderData";
import GroupData from "./GroupData";

interface StorageData {
    dataSelector: SourceSelector,
    isFilteringEnabled: boolean, // works only for colors by attributes (slider and group)
    is_smart_rounding_enabled: boolean,
    sliderData: any,
    groupData: any,
}

class ColorizerStorage {

    static localStorageName: string = 'colorizerStorage';
    static defaultColorForUnassigned: string = '#CCCCCC';
    static storage: StorageData = {
        dataSelector: 'sliderData',
        isFilteringEnabled: false,
        is_smart_rounding_enabled: false,
        sliderData: {},
        groupData: {},
    };

    public static loadFromLocalStorage(): void {
        ColorizerStorage.storage = Object.assign(ColorizerStorage.storage, JSON.parse(localStorage.getItem(ColorizerStorage.localStorageName) || '{}'));
        console.log('ColorizerStorage.loadFromLocalStorage()', ColorizerStorage.storage);
    }

    private static saveToLocalStorage(): void {
        localStorage.setItem(ColorizerStorage.localStorageName, JSON.stringify(ColorizerStorage.storage));
        console.log('ColorizerStorage.saveToLocalStorage()', ColorizerStorage.storage);
    }

    public static setSliderData(sliderData: any, setAsSelectedSource: boolean = true): void {
        ColorizerStorage.storage.sliderData = JSON.parse(JSON.stringify(sliderData));
        if (setAsSelectedSource) {
            ColorizerStorage.storage.dataSelector = 'sliderData';
        }
        ColorizerStorage.saveToLocalStorage();
    }

    public static setGroupData(groupData: any, setAsSelectedSource: boolean = true): void {
        ColorizerStorage.storage.groupData = JSON.parse(JSON.stringify(groupData));
        if (setAsSelectedSource) {
            ColorizerStorage.storage.dataSelector = 'groupData';
        }
        ColorizerStorage.saveToLocalStorage();
    }

    public static getSData(): any {
        return JSON.parse(JSON.stringify(ColorizerStorage.storage.sliderData));
    }

    public static getGData(): any {
        return JSON.parse(JSON.stringify(ColorizerStorage.storage.groupData));
    }

    public static getDataSelector(): SourceSelector {
        return ColorizerStorage.storage.dataSelector;
    }

    public static getSelectedOption(): string {
        let selectedOption = '';
        switch (ColorizerStorage.getDataSelector()) {
            case 'sliderData': {
                selectedOption = ColorizerStorage.getSData().selected_option;
                break;
            }
            case 'groupData': {
                selectedOption = ColorizerStorage.getGData().selected_option;
                break;
            }
        }
        return selectedOption;
    }

    public static getUnit(): string {
        let unit = '';
        switch (ColorizerStorage.getDataSelector()) {
            case 'sliderData': {
                unit = ColorizerStorage.getSData().unit;
                break;
            }
            case 'groupData': {
                // groupData has no unit
                break;
            }
        }
        return unit;
    }

    public static getColorForTransmitterOrNull(transmitter: any): string | null {
        if (ColorizerStorage.storage.isFilteringEnabled === false) {
            return null;
        }
        return ColorizerStorage.getColorForTransmitter(transmitter);
    }

    public static getColorForTransmitter(transmitter: any): string {
        let color = ColorizerStorage.defaultColorForUnassigned.replace('#', ''); // pink
        if (transmitter) {
            switch (ColorizerStorage.getDataSelector()) {
                case 'sliderData': {
                    let selected_option = ColorizerStorage.getSData().selected_option;
                    if (typeof transmitter[selected_option] === 'undefined') {
                        console.error('Undefined key ', selected_option, ' in transmitter ', transmitter);
                    } else {
                        let sliderData = (new SliderData()).load(ColorizerStorage.getSData());
                        color = sliderData.getColorForValue(transmitter[selected_option], { withoutHash: true });
                    }
                    break;
                }
                case 'groupData': {
                    let groupData = (new GroupData()).load(ColorizerStorage.getGData());
                    if (groupData) {
                        switch (groupData.getTypeName()) {
                            case 'group_id': {
                                if (transmitter?.groups_ids?.length > 0) {
                                    color = groupData.getColorForValue(transmitter.groups_ids[0], { withoutHash: true }) || color;
                                }
                                break;
                            }
                            default:
                                if (typeof transmitter[groupData.getTypeName()] === 'undefined') {
                                    console.error('Undefined key ', groupData.getTypeName(), ' in transmitter ', transmitter);
                                } else {
                                    color = groupData.getColorForValue(transmitter[groupData.getTypeName()], { withoutHash: true }) || color;
                                }
                        }
                    }
                    break;
                }
            }
        } else {
            console.warn('ColorizerStorage, getColorForTransmitter, transmitter is undefined');
        }
        return color;
    }

    public static getIsFilteringEnabled(): boolean {
        return ColorizerStorage.storage.isFilteringEnabled;
    }

    public static getIsSmartRoundingEnabled(): boolean {
        // return ColorizerStorage.storage.sliderData.is_smart_rounding_enabled;
        return ColorizerStorage.storage.is_smart_rounding_enabled;
    }

    public static setIsSmartRoundingEnabled(isSmartRoundingEnabled: boolean): void {
        // ColorizerStorage.storage.sliderData.is_smart_rounding_enabled = isSmartRoundingEnabled;
        ColorizerStorage.storage.is_smart_rounding_enabled = isSmartRoundingEnabled;
        ColorizerStorage.saveToLocalStorage();
    }

    public static setIsFilteringEnabled(isFilteringEnabled: boolean): void {
        console.log('ColorizerStorage.setIsFilteringEnabled', isFilteringEnabled);
        ColorizerStorage.storage.isFilteringEnabled = isFilteringEnabled;
        ColorizerStorage.saveToLocalStorage();
    }
}

export default ColorizerStorage;